import React from 'react';
import {
  Card,
  CardActionArea,
  CardMedia,
  Drawer,
  IconButton,
  makeStyles
} from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { Close } from '@material-ui/icons';
import { CustomizedTypography } from '@components/Customized';
import * as assets from '@assets';

interface DesignHelperDrawerProps {
  open: boolean;
  onClose: () => void;
  matches: boolean;
}

const designHelpContent = [
  {
    title: '제품디자인',
    content: `전자제품부터 가구, 자동차, 휴대전화 등 보통 대량생산을 목적으로 생산하는 제품의 외관을 심미성을 고려해 디자인하는 것을 의미합니다. 구체적으로 제품에 대한 아이디어를 스케치한 결과물을 3D 모델링으로 제작해 완성합니다.`
  },
  {
    title: '기구설계',
    content: `제품 디자인이 실제 제품으로 구현될 수 있도록 '제조성'을 고려해 설계하는 것을 말합니다. 예를 들어, 접거나 이송이 필요한 경우 힌지나 슬라이더를 배치하여 의도한 기능이 구현되도록 설계하는 것입니다. 또한 밀링이나 금형 사출 등 어떤 제조 기술을 사용하느냐를 고려해 이같은 가공방식에 맞게 생산할 수 있도록 외형을 수정하는 행위도 기구 설계에 포함됩니다.`
  }
];

const DesignHelperDrawer: React.FC<DesignHelperDrawerProps> = ({
  open,
  onClose,
  matches
}) => {
  const { paper, header, content, blogContent } = useStyles();

  return (
    <Drawer
      anchor={matches ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      classes={{
        paper
      }}
    >
      <div className={header}>
        <IconButton onClick={onClose} color="inherit">
          <Close />
        </IconButton>
        <CustomizedTypography className="title" variant="body1" color="inherit">
          도움말
        </CustomizedTypography>
      </div>
      <div className={content}>
        {designHelpContent.map((helper) => (
          <div key={helper.title}>
            <CustomizedTypography
              variant="subtitle1"
              fontWeight="500"
              color="inherit"
              gutterBottoms={4}
            >
              {helper.title}
            </CustomizedTypography>
            <CustomizedTypography
              variant="body2"
              color="inherit"
              className="content-text"
            >
              {helper.content}
            </CustomizedTypography>
          </div>
        ))}
        <Card className={blogContent}>
          <CardActionArea
            onClick={() => {
              window.open(
                'https://capa.ai/blog/posts/%EC%A0%9C%ED%92%88-%EB%94%94%EC%9E%90%EC%9D%B8%EA%B3%BC-%EA%B8%B0%EA%B5%AC-%EC%84%A4%EA%B3%84-%EC%A0%9C%EC%A1%B0%EC%9D%98-%EC%B2%AB%EA%B1%B8%EC%9D%8C%EC%9D%84-%EC%8B%9C%EC%9E%91%ED%95%98%EC%84%B8',
                '_blank'
              );
            }}
          >
            <CardMedia
              className="media"
              image={assets.DesignHelperDrawerImage}
            />
            <div className="blog-title">
              <CustomizedTypography variant="body2" color="inherit">
                제품디자인과 기구설계,제조의 첫걸음을 시작하세요
              </CustomizedTypography>
              <CustomizedTypography variant="subtitle2" color="textSecondary">
                2분 분량의 글
              </CustomizedTypography>
            </div>
          </CardActionArea>
        </Card>
      </div>
    </Drawer>
  );
};

export default DesignHelperDrawer;

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: colorSet.gray2000,
    color: colorSet.gray000,
    alignItems: 'center',
    height: '100vh',
    [theme.breakpoints.up('md')]: {
      maxWidth: '375px',
      overflow: 'scroll'
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: 16,
    '& button > svg': {
      color: colorSet.gray000
    },
    '& .title': {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    padding: 24,
    '& .content-text': {
      wordBreak: 'break-all'
    }
  },
  blogContent: {
    backgroundColor: colorSet.gray1000,
    borderRadius: '12px',
    '& .media': {
      height: '160px',
      width: '100%',
      backgroundSize: 'cover'
    },
    '& .blog-title': {
      padding: 16,
      color: colorSet.gray000
    }
  }
}));
